export class form_data{
    user_input:any;

}